import { useAppStore, useWebviewStore } from '@/store'
import { exitSDK, finishOrderPay, getDeviceId, getSDKParam } from '@/utils/native'

interface SDKParam {
  /** 设备ID/设备编码 设备的唯一标识 */
  deviceId: string
  /** 支付入口/业务场景 用于标识进入支付sdk的入口 */
  entrance: string
  postData: string
  /** 订单参数 */
  preOrder: string
  /** 会话ID */
  sessionId: string
  /** 令牌 */
  token: string
}

interface DeviceId {
  /** 设备ID 设备编码 设备的唯一标识 */
  deviceId: string
  /** 版本 */
  version: string
}

const postMessage = (params: any) => {
  if (useWebviewStore().isWechatMiniProgram) return window.wx.miniProgram.postMessage(params)
  return window.my.postMessage(params)
}

const navigateBack = () => {
  if (useWebviewStore().isWechatMiniProgram) return window.wx.miniProgram.navigateBack()
  return window.my.navigateBack()
}

const redirectTo = (params: any) => {
  if (useWebviewStore().isWechatMiniProgram) return window.wx.miniProgram.redirectTo(params)
  return window.my.redirectTo(params)
}

export default function useNative() {
  const appStore = useAppStore()
  const webviewStore = useWebviewStore()
  const { isFromMiniProgram, isFromH5, redirectUrl, orderId } = webviewStore
  const joinDot = redirectUrl?.includes('?') ? '&' : '?'

  const exit = (params?: any) => {
    /** 小程序退出 */
    if (isFromMiniProgram) {
      if (params) {
        postMessage({
          data: { params, action: 'exitSDK' },
        })
      }
      navigateBack()
      return
    }

    /** 商城H5退出 */
    if (isFromH5) {
      const action =
        params && params.exitCode && params.exitCode === -2 ? 'tokenExpired' : 'exitSDK'
      location.replace(`${redirectUrl}${joinDot}action=${action}`)
      return
    }

    /** 澳觅APP退出 */
    exitSDK(params)
  }

  const finishPay = (params) => {
    // 支付完成后退出sdk并跳转到外部应用的支付结果页
    const { payType } = appStore

    console.log('[是否小程序] ', isFromMiniProgram)
    console.log('[是否商城H5] ', isFromH5)

    if (isFromMiniProgram) {
      let url = ''
      if (params.freeOrder === 'Y') {
        url = `${redirectUrl}${joinDot}id=${orderId}`
      } else {
        url = `${redirectUrl}${joinDot}id=${orderId}&total=${
          params.buyerPayAmount / 100
        }&type=${payType}`
      }

      console.log('[跳转到小程序的地址] ', url)
      redirectTo({ url })

      return
    }

    if (isFromH5) {
      location.replace(`${redirectUrl}${joinDot}action=finishOrderPay`)
      return
    }

    finishOrderPay(params)
  }

  const getLoginParams = async (): Promise<SDKParam> => {
    return new Promise(async (resolve) => {
      try {
        console.log('[getSDKParam] ', getSDKParam)
        const paramsJson: string = <string>await getSDKParam()
        const initParams: SDKParam = JSON.parse(paramsJson)
        console.log('[桥接获取的初始化SDK参数] ', initParams)

        const deviceNoStr: string = <string>await getDeviceId() || ''
        console.log('[桥接获取的设备信息] ', JSON.parse(JSON.stringify(deviceNoStr)))
        const deviceNoJson: DeviceId = JSON.parse(deviceNoStr)
        initParams.deviceId = deviceNoJson.deviceId

        return resolve(initParams)
      } catch (error) {
        console.log('[捕获获取桥接参数错误] ', error)
      }
    })
  }

  return {
    exit,
    finishPay,
    getLoginParams,
  }
}
